interface ISystemPermissions {
	global: Map<string, boolean>;
	station: Map<string, number[]>;
}

export class SystemPermissions {
	readonly global: Map<string, boolean>;
	readonly station: Map<string, number[]>;
	constructor(values: ISystemPermissions) {
		this.global = new Map<string, boolean>(
			Object.entries(values.global as unknown as { [key: string]: boolean }),
		);

		this.station = new Map<string, number[]>(
			Object.entries(values.station as unknown as { [key: string]: number[] }),
		);
	}

	hasPermission(intent: string, station?: number) {
		if (station === undefined) {
			return Boolean(this.global.get(intent));
		}
		return this.station.get(intent)?.some((stationId) => stationId === station);
	}
}

export function hasPermissionOnSystem(
	permissionMap: Map<string, SystemPermissions>,
	system: string,
	intent: string,
	station?: number,
) {
	return permissionMap.get(system)?.hasPermission(intent, station);
}

// export function hasPermissionInAnySystem(permissionMap: Map<string, SystemPermissions>, intent: string) {
// 	return [...permissionMap.values()].some((permissions) => {
// 		return permissions.hasPermission(intent);
// 	});
// }
